import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useFetch from "../../../utils/useFetch";
import GetfVDateFormate from '../../../utils/Genaricfunctions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


export default function EmployeeView({ data, close, userid, isMoodleEmployee,fvuserid }) {
    const [GetViewEmployeeCategories, setGetViewEmployeeCategories] = useState([]);
    const { data: res } = useFetch(
        "Employee/GetEmployeeCategories?userid="+fvuserid
    );

    const [spinner, setSpinner] = React.useState(true);
    useEffect(() => {
        if (res?.data) {
            setGetViewEmployeeCategories(res?.data);
            setSpinner(false);
        }
    }, [res]);

    return (
        <>
            <Backdrop
 sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
 open={spinner}
// onClick={SpinnerClose}
 >
<CircularProgress color="inherit" />
 </Backdrop>
            <DialogTitle id="alert-dialog-title">

                <span><span style={{ fontSize: "20px" }}> {"Category Status History"}</span> <span style={{ float: "right" }}><CloseIcon onClick={close} style={{ cursor: "pointer" }} /></span></span>
            </DialogTitle>
            <ToastContainer />
            <DialogContent>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Category Name</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }} align="center">Category Input</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }} align="center">Category Entered Date </TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }} align="center">Category AssignedBy</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {GetViewEmployeeCategories?.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    hidden={row?.subCategorySelectedValue==null}
                                >
                                    <TableCell style={{ fontSize: "13px" }}>{row?.categoryName}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }} align="center">{row?.subCategorySelectedValue ? row?.subCategorySelectedValue : "-"}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }} align="center">
                                        {/* {row.subCategoryEnteredDate ? moment(row.subCategoryEnteredDate).utc().format(' MM/DD/YYYY') : "-"} */}
                                        {row?.subCategoryEnteredDate != null ? GetfVDateFormate("", row?.subCategoryEnteredDate) : row?.subCategoryEnteredDate}
                                        </TableCell>
                                    <TableCell style={{ fontSize: "13px" }} align="center">{row?.assignedBy ? row?.assignedBy : "-"}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <DialogActions>
                    <div className="login-help__buttonContainer">


                    </div>
                </DialogActions>
            </DialogContent>


        </>
    )
}
